/*  =============================================
    Copyright © Hugo B.V. (acting under the brand name "Quriobot") - All Rights Reserved
    =============================================

    - Unauthorized copying of this file, via any medium is strictly prohibited
    - Proprietary and confidential
    - By using the Quriobot Website and/or Services, you signify you have read and
      accepted the Terms of Service on https://quriobot.com/terms of this Website and Services.
      If you do not agree to these Conditions, do not use Quriobot Website and/or Services.
    - Written by the good people of Hugo B.V. (acting under the brand name "Quriobot"), hello@quriobot.com, December 2016

    ============================================= */

var Locales = new Class({
    getLocale:function(){
        return (this.locale)? this.locale : 'en_US';
    },
    translate:function(text){
        if(typeOf(text) == 'object'){
            if(text[this.getLocale()]){
                return text[this.getLocale()]
            }else{
                var fallback = [];
                for(key in text){
                    if (Object.prototype.hasOwnProperty.call(text.hasOwnProperty, key)) {
                      fallback.push(text[key])
                    }
                }
                return fallback[0];
            }
        }else{
            return text;
        }
    }
});
